import React from 'react'
import { Container, Wrapper } from './style';
import { BrowserRouter as Router, Route } from 'react-router-dom'
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import { navItems } from '../utils/navbar'
import SearchHeader from '../components/SearchHeader'
function App() {
  return (
    <Container>
      <Router>
        <SearchHeader />
        <Navbar />
        <Wrapper>
          {
            navItems.map(({ path, component }) => {
              return (
                <Route key={path} path={path} component={component} />
              )
            })
          }
        </Wrapper>
        <Footer />
      </Router>
    </Container>
  );
}

export default App;
